import type { UseEmojiPickerType } from "@platejs/emoji/react";
import styles from "./emoji.module.scss";
import { ReactNode } from "react";

export type EmojiPickerSearchBarProps = {
  children: ReactNode;
} & Pick<UseEmojiPickerType, "i18n" | "searchValue" | "setSearch">;

export function EmojiPickerSearchBar({
  children,
  i18n,
  searchValue,
  setSearch,
}: EmojiPickerSearchBarProps) {
  return (
    <div className={styles.emojiSearch}>
      <div>
        {children}
        <input
          value={searchValue}
          onChange={(event) => setSearch(event.target.value)}
          placeholder={i18n.search}
          aria-label="Search"
          autoComplete="off"
          type="text"
          autoFocus
        />
      </div>
    </div>
  );
}
